module.exports = __webpack_public_path__ + "static/increase-conversion-bddf03c3dd79e3c22e31f15fc3fa8ddb.png";